var _rect, _path, _path2, _path3, _path4, _circle, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPrices = function SvgPrices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 80,
    rx: 8,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m73.868 12.497-3.912-.064-11.797-.153a9 9 0 0 0-6.48 2.635L31.16 35.433a9 9 0 0 0 0 12.728l15.624 15.623a9 9 0 0 0 12.728 0l20.615-20.616a9 9 0 0 0 2.636-6.244l.153-11.53-.206-4.326a9 9 0 0 0-8.842-8.57Zm-8.165 16.744a3.437 3.437 0 1 0 4.86-4.86 3.437 3.437 0 0 0-4.86 4.86Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m76 54.846-1.444-.278c-2.143-.412-3.125-2.916-1.835-4.675l.907-1.236-1.958-1.958-1.217.825c-1.806 1.224-4.272.148-4.604-2.008L65.615 44h-2.769l-.359 1.865c-.403 2.096-2.818 3.096-4.585 1.899l-1.572-1.065-1.958 1.958.907 1.236c1.29 1.76.308 4.263-1.835 4.675L52 54.846v2.769l1.515.233c2.157.332 3.232 2.797 2.008 4.604l-.825 1.217 1.958 1.958 1.236-.907c1.76-1.29 4.263-.308 4.675 1.835L62.846 68h2.769l.164-1.066c.339-2.204 2.896-3.263 4.694-1.944l.869.638L73.3 63.67l-.825-1.217c-1.224-1.806-.148-4.272 2.008-4.604L76 57.615v-2.769Z",
    fill: "#F7F7F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5Zm0-8c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m69.697 13.583 3.567.059a9 9 0 0 1 8.842 8.57l.19 3.97-.149 11.107a9 9 0 0 1-2.635 6.244l-19.79 19.79a9 9 0 0 1-12.729 0L32.161 48.493a9 9 0 0 1 0-12.728L51.854 16.07a9 9 0 0 1 6.48-2.635l11.362.147Z",
    fill: "url(#prices_svg__a)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.925,
    cy: 27.56,
    r: 3.341,
    transform: "rotate(45 67.925 27.56)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m76.617 54.813-1.404-.27c-2.083-.4-3.038-2.835-1.784-4.545l.882-1.201-1.904-1.904-1.183.802c-1.755 1.19-4.153.144-4.475-1.952l-.228-1.474H63.83l-.35 1.814c-.391 2.037-2.739 3.01-4.456 1.846l-1.529-1.036-1.903 1.904.882 1.201c1.254 1.711.3 4.144-1.784 4.545l-1.404.27v2.692l1.473.226c2.097.323 3.142 2.72 1.952 4.476l-.802 1.183 1.903 1.903 1.202-.882c1.71-1.254 4.144-.299 4.544 1.784l.272 1.405h2.691l.16-1.036c.33-2.143 2.815-3.172 4.563-1.89l.844.62 1.904-1.903-.802-1.183c-1.19-1.756-.144-4.153 1.952-4.476l1.475-.227v-2.692Z",
    fill: "#5298F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.951 60.795c-2.68 0-4.86-2.18-4.86-4.86s2.18-4.86 4.86-4.86 4.86 2.18 4.86 4.86-2.18 4.86-4.86 4.86Zm0-7.777a2.92 2.92 0 0 0-2.916 2.917 2.92 2.92 0 0 0 2.916 2.916 2.92 2.92 0 0 0 2.917-2.916 2.92 2.92 0 0 0-2.917-2.917Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prices_svg__a",
    x1: 57.001,
    y1: 116,
    x2: 57.001,
    y2: -6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384952",
    stopOpacity: 0
  })))));
};

export default SvgPrices;